<template>
  <v-dialog v-model="show" max-width="20rem" @click:outside="close">
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text
        v-html="message"
        style="min-height: 5rem;display: flex;align-items: center;justify-content: center;"
      >
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-0">
        <v-btn width="100%" text x-large @click="close">
          {{ $t('point.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    message: String,
    close: Function
  },
  methods: {}
}
</script>

<style></style>
